export default __webpack_public_path__ + "static/media/school-screetshot.33d7613a.png";